module.exports = __webpack_public_path__ + "img/neck.645fd08a.svg";